import React from 'react';
import {Control, Link, Button} from 'MWComponents';
import Calculator from '../../../auxiliary-components/Calculator';
import '../less/newInstallment.less';
import { Preloader } from 'MWC';
import {LANG} from '../../../services/l10n';
import how_to_1 from "../img/how_to/how_to_1.svg";
import how_to_2 from "../img/how_to/how_to_2.svg";
import how_to_3 from "../img/how_to/how_to_3.svg";
import Banner from "../../../auxiliary-components/shared/Banner";
import newInstallment_banner_img from "../img/newInstallment_banner-new.png";
import TabsNew from "../../../auxiliary-components/shared/TabsNew";
import UsageBlock from "../../../auxiliary-components/shared/UsageBlock";
import usage_block_data from "../enums/pbp_usage_block_data.json";
import QuestionsBlock from "../../../auxiliary-components/shared/QuestionsBlock";
import questions from "../enums/pbp_questions.json";
import HowToBlock from "../../../auxiliary-components/shared/HowToBlock";
import TextAboveFooter from "../../../auxiliary-components/shared/TextAboveFooter/views/TextAboveFooter.c";
import FilesForDownload from "../../../auxiliary-components/shared/FilesForDownload/views/file.c";



export default function template() {
    const isMobile = this.isViewportMobile(),
        {viewport} = this.props,
        modes = [ {mode: 'info', title: 'GREEN_CARD_NAV_TITLE_1'},
            {mode: 'questions', title: 'GREEN_CARD_NAV_TITLE_3'}],
        page = 'new-installment',
        howToItems = [
            { img: how_to_1, text: 'NEW_INSTALLMENT_HOW_TO_TEXT_1' },
            { img: how_to_2, text: 'NEW_INSTALLMENT_HOW_TO_TEXT_2' },
            { img: how_to_3, text: 'NEW_INSTALLMENT_HOW_TO_TEXT_3' }],

        model = this.getModel();

    if (model.setRealRate) {
        model.setRealRate(this.l10n('CALCULATOR_CREDIT_CARDS_REAL_YEAR_RATE_1'));
    }

    const calculator = !model.creditSum ? (
        ''
    ) : (
        <div className="credit-calculator">
            <div className="calculator-wrapper">
                <Calculator model={this.getModel()} type="payment-parts" {...this.props} />
            </div>
        </div>
    ),

    payByPartsFile = 'https://conditions-and-rules.a-bank.com.ua/media/uploads/Kredit/NR/Istot_NR_ua.pdf',
    payByPartsFile2 = 'https://conditions-and-rules.a-bank.com.ua/main/view-content-460/?lang=uk',
    payByPartsFile3 = 'https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/NR_ua.pdf',
    payByPartsFile4 = 'https://conditions-and-rules.a-bank.com.ua/media/uploads/Kredit/NR/Pas_NR.pdf';


    return !model.creditSum ? (
        <div className="preload-wrapper">
            <Preloader />
        </div>
    ) : (
           <div className="new-installment">
               <Banner
                   img={newInstallment_banner_img}
                   text={'CARDS_NEW_INSTALLMENT_SUBTITLE'}
                   textMob={'CARDS_NEW_INSTALLMENT_SUBTITLE'}
                   title={'CARDS_NEW_INSTALLMENT_TITLE'}
                   toggleModal={null}
                   page={page}
                   isMobile={isMobile}>
               </Banner>

               <TabsNew modes={modes} isMobile={isMobile} page={page} toggle={this.toggleMode} mode={this.state.mode}>
                   <div className="wrapper" type={modes[0].mode}>
                       <div className="content">
                           <UsageBlock isMobile={isMobile} page={page} data={usage_block_data} className="col-3-row-1"></UsageBlock>

                           <div className="credit-calculator">
                               <div className="calculator-wrapper">
                                   <Calculator model={this.getModel()} type={this.state.selectedType} {...this.props} />
                               </div>
                           </div>

                           <div className="how-to-block-wrapper">
                               <div className="block-title" style={{fontSize: 32, paddingBottom: 32}}>{this.l10n("NEW_INSTALLMENT_HOW_TO_TITLE")}</div>
                               <HowToBlock data={howToItems} isMobile={isMobile} page={page}></HowToBlock>
                           </div>



                       </div>
                   </div>
                   <div className="wrapper" type={modes[1].mode}>
                       <div className="content">
                           <QuestionsBlock isMobile={isMobile} page={page} data={questions}></QuestionsBlock>
                       </div>
                   </div>
               </TabsNew>

             <FilesForDownload lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, "files_to_download")}/>

               <div className={`disclaimer-wrapper tab-${(this.state.mode !== 'info' ? "hidden" : 'active')}`}>
                   <TextAboveFooter widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')} isMobile={isMobile} />
               </div>
           </div>
        );
}
